// Filter contract for the `/rules` browser (ui-spec §10.6) — kept here
// (not in ui-url-state) because the same filter shape is consumed by the
// TanStack Query keys and the PostgREST query builder. The url-state hook
// re-exports the schema so it lives in one place.
//
// Per ADR-0010, all values come from the canonical `rules` table enums
// in db-types.ts; we never invent filter values that don't map to a
// documented column.

import type { Database } from '@observatory/shared/db-types.ts';

export type RuleStatus = Database['public']['Enums']['rule_status'];
export type RuleType = Database['public']['Enums']['rule_type'];
export type RuleSource = Database['public']['Enums']['rule_source'];

export const RULE_STATUSES = [
  'proposed',
  'active',
  'inactive',
] as const satisfies readonly RuleStatus[];
export const RULE_TYPES = [
  'alias',
  'category',
  'internal_transfer',
  'ignore',
] as const satisfies readonly RuleType[];
export const RULE_SOURCES = [
  'migrated_v1',
  'manual',
  'agent_proposed',
  'agent_committed',
] as const satisfies readonly RuleSource[];

export interface RulesFilters {
  readonly status?: RuleStatus;
  readonly type?: RuleType;
  readonly source?: RuleSource;
}

export function isRuleStatus(value: unknown): value is RuleStatus {
  return typeof value === 'string' && (RULE_STATUSES as readonly string[]).includes(value);
}
export function isRuleType(value: unknown): value is RuleType {
  return typeof value === 'string' && (RULE_TYPES as readonly string[]).includes(value);
}
export function isRuleSource(value: unknown): value is RuleSource {
  return typeof value === 'string' && (RULE_SOURCES as readonly string[]).includes(value);
}
